import Select from "react-select"; // ✅
import React, { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import {
  getservice_Categories,
  getCourt_Case_Types,
} from "../../services/Common";

const CaseBasicInfo = ({
  control,
  errors,
  lang,
  enPhrase,
  arPhrase,
  isLoading,
  isRtl,
  isSearchable,
  courts,
  caseTypes,
  years,
  partyTypes,
  sharedValues,
  setSharedValues,
  clearErrors,
  register,
  CustomDropdownIndicator,
  formatOptionLabel,
  optionsYear,
  setServiceCaregories,
  resetAllDisclosures,
  setCaseTypes,
  setValue,
  setMobileNumber,
  mobileNumber,
  trigger,
}) => {
  const [isCaseTypesLoading, setIsCaseTypesLoading] = useState(false);
  const [countries, setCountries] = useState([]);

  // ✅ full width dropdown menu = full width of (country+mobile wrapper)
  const phoneWrapRef = useRef(null);
  const [phoneWrapWidth, setPhoneWrapWidth] = useState(0);

  const isCaseTypeDisabled =
    !sharedValues?.court?.id || isCaseTypesLoading || !caseTypes?.length;

  function customTheme(theme) {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary25: "#F9F7ED",
        primary: "#B68A35",
        neutral0: "white",
      },
    };
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: state.isDisabled ? "#EFEFEF" : "#fff",
      borderRadius: 4,
      "*": {
        boxShadow: "none !important",
      },
      backgroundColor: state.isFocused ? "#fffff0" : "#fff",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
      height: "auto",
      overflow: "auto",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      backgroundColor: "#fff",
      maxHeight: "200px",
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      backgroundColor: isSelected ? "#B68A35" : isFocused ? "#F9F7ED" : "white",
      color: isSelected ? "white" : "black",
      ":hover": {
        backgroundColor: isSelected ? "#B68A35" : "#F9F7ED",
        color: "black",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
  };

  const measurePhoneWrap = () => {
    if (phoneWrapRef.current) {
      setPhoneWrapWidth(phoneWrapRef.current.getBoundingClientRect().width);
    }
  };

  useEffect(() => {
    // after first render
    requestAnimationFrame(measurePhoneWrap);

    const onResize = () => requestAnimationFrame(measurePhoneWrap);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    // RTL/LTR may change width
    requestAnimationFrame(measurePhoneWrap);
  }, [lang]);

  useEffect(() => {
    if (lang === "en") {
      const data = require("../../components/ContactusModel/countriesEn.json");
      setCountries(data);
    } else {
      const dataAr = require("../../components/ContactusModel/countriesAr.json");
      setCountries(dataAr);
    }
  }, [lang]);

  const formatOptionLabelCode = ({ name, dial_code, code }, { context }) => {
    if (context === "menu") {
      return (
        <div className="flex flex-row gap-[8px] items-center">
          <div className="flex flex-row gap-[8px] items-center">
            <img
              alt={name}
              src={`http://www.geonames.org/flags/x/${code.toLowerCase()}.gif`}
              className="w-[15px] h-[15px] md:w-[24px] md:h-[15px] rounded-sm"
              onError={(e) => {
                e.target.src = "/path-to-fallback-image/fallback.png";
              }}
            />
            <span className="text-[#333] text-[12px]" dir="ltr">
              {dial_code}
            </span>
          </div>
          <span className="text-[#333] text-[12px] text-center">{name}</span>
        </div>
      );
    }

    return (
      <div className="flex flex-row gap-[30px] items-center">
        <div className="flex flex-row gap-[8px] items-center">
          <img
            src={`http://www.geonames.org/flags/x/${code.toLowerCase()}.gif`}
            alt="country-image"
            className="w-[15px] h-[15px] md:w-[24px] md:h-[16px] rounded-sm"
          />
          <span
            className="text-[#333] font-Almarai font-bold text-[12px]"
            dir="ltr"
          >
            {dial_code}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full xl:w-[384px] min-h-[484px] bg-[#fff] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] py-[24px] gap-[24px]">
      <div className="flex flex-row gap-[24px] mb-[24px]">
        <img
          src="/assets/img/add-request/Rectangle.svg"
          alt="icon"
          className={`${lang === "en" ? "rotate-180" : ""}`}
        />
        <div className="flex flex-col">
          <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
            {lang === "en"
              ? enPhrase["lblCaseDetails"]
              : arPhrase["lblCaseDetails"]}
          </p>
          <p className="font-Almarai font-400 text-[11px] leading-[18px] text-[#6F6A62]">
            {lang === "en"
              ? enPhrase["lblBasicInfo"]
              : arPhrase["lblBasicInfo"]}
          </p>
        </div>
      </div>

      <div className="px-[24px] flex flex-col gap-[16px]">
        {/* ---------------- Court ---------------- */}
        <div>
          <label
            htmlFor="court"
            className={`block text-[12px] ${
              errors.court
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblCourtRentalDisputesCenter"]
              : arPhrase["lblCourtRentalDisputesCenter"]}
          </label>

          <Controller
            name="court"
            rules={{ required: "court is required" }}
            control={control}
            render={({ field }) => (
              <Select
                components={{ DropdownIndicator: CustomDropdownIndicator }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblCourtRentalDisputesCenterPlaceholder"]
                      : arPhrase["lblCourtRentalDisputesCenterPlaceholder"]}
                  </div>
                }
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.court ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={courts?.[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                options={courts}
                getOptionLabel={(o) => o["name"]}
                getOptionValue={(o) => o["id"]}
                formatOptionLabel={formatOptionLabel}
                onChange={async (selected) => {
                  field.onChange(selected);
                  clearErrors("court");
                  resetAllDisclosures();
                  setValue("caseType", null);

                  setSharedValues((prev) => ({
                    ...prev,
                    court: selected,
                    caseType: null,
                  }));

                  setCaseTypes([]);
                  setIsCaseTypesLoading(true);

                  if (!selected?.id) {
                    setServiceCaregories([]);
                    setSharedValues((prev) => ({
                      ...prev,
                      serviceCategories: [],
                    }));
                    setIsCaseTypesLoading(false);
                    return;
                  }

                  try {
                    const [categoriesRes, caseTypesRes] = await Promise.all([
                      getservice_Categories(lang, selected.id),
                      getCourt_Case_Types(lang, selected.id),
                    ]);

                    setSharedValues((prev) => ({
                      ...prev,
                      serviceCategories: categoriesRes ?? [],
                    }));
                    setServiceCaregories(categoriesRes ?? []);

                    setCaseTypes(caseTypesRes ?? []);
                  } catch (e) {
                    console.error(e);
                    setServiceCaregories([]);
                    setSharedValues((prev) => ({
                      ...prev,
                      serviceCategories: [],
                    }));
                    setCaseTypes([]);
                  } finally {
                    setIsCaseTypesLoading(false);
                  }
                }}
              />
            )}
          />

          {errors.court && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["drpdwn_Court_error"]
                : arPhrase["drpdwn_Court_error"]}
            </span>
          )}
        </div>

        {/* ---------------- Case Type ---------------- */}
        <div>
          <label
            htmlFor="caseType"
            className={`block text-[12px]  ${
              errors.caseType
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblCaseTypeEnforcement"]
              : arPhrase["lblCaseTypeEnforcement"]}
          </label>

          <Controller
            name="caseType"
            rules={{ required: "Case Type is required" }}
            control={control}
            render={({ field }) => (
              <Select
                components={{ DropdownIndicator: CustomDropdownIndicator }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblCaseTypeEnforcementPlaceholder"]
                      : arPhrase["lblCaseTypeEnforcementPlaceholder"]}
                  </div>
                }
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.caseType ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                isDisabled={isCaseTypeDisabled}
                classNamePrefix="select"
                isRtl={isRtl}
                isSearchable={isSearchable}
                options={caseTypes}
                getOptionLabel={(o) => o["name"]}
                getOptionValue={(o) => o["id"]}
                formatOptionLabel={formatOptionLabel}
                filterOption={(candidate, input) =>
                  candidate.data.nameForSearch
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    caseType: selected,
                  }));
                  clearErrors("caseType");
                }}
              />
            )}
          />

          {errors.caseType && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lbl_Error_Case_Type"]
                : arPhrase["lbl_Error_Case_Type"]}
            </span>
          )}
        </div>

        {/* ---------------- Case Number ---------------- */}
        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="caseNumber"
            className={`block text-[12px]  ${
              errors.caseNumber
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblCaseNumber"]
              : arPhrase["lblCaseNumber"]}
          </label>

          <input
            type="text"
            name="caseNumber"
            key="caseNumber"
            placeholder={
              lang === "en"
                ? enPhrase["lblCaseNumberHolder"]
                : arPhrase["lblCaseNumberHolder"]
            }
            aria-invalid={errors.caseNumber ? "true" : "false"}
            {...register("caseNumber", {
              required: true,
              onChange: (e) => {
                clearErrors("caseNumber");
                setSharedValues((prev) => ({
                  ...prev,
                  caseNumber: e.target.value,
                }));
              },
            })}
            className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 !text-[14px] sm:text-sm leading-[20px] ${
              errors.caseNumber ? " border-red-600" : " border-gray-300"
            }`}
          />

          {errors.caseNumber && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lbl_Case_Number_Error"]
                : arPhrase["lbl_Case_Number_Error"]}
            </span>
          )}
        </div>

        {/* ---------------- Year ---------------- */}
        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="caseYear"
            className={`block text-[12px]  ${
              errors.caseYear
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en" ? enPhrase["lblYear"] : arPhrase["lblYear"]}
          </label>

          <Controller
            name="caseYear"
            rules={{ required: "case Year is required" }}
            control={control}
            render={({ field }) => (
              <Select
                components={{ DropdownIndicator: CustomDropdownIndicator }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblYearHolder"]
                      : arPhrase["lblYearHolder"]}
                  </div>
                }
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.caseYear ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={optionsYear?.[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                options={optionsYear}
                getOptionLabel={(o) => o["name"]}
                getOptionValue={(o) => o["id"]}
                formatOptionLabel={formatOptionLabel}
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    caseYear: selected,
                  }));
                  clearErrors("caseYear");
                }}
              />
            )}
          />

          {errors.caseYear && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lbl_Error_Case_Year"]
                : arPhrase["lbl_Error_Case_Year"]}
            </span>
          )}
        </div>

        {/* ---------------- User Type ---------------- */}
        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="customer"
            className={`block text-[12px]  ${
              errors.customer
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en" ? enPhrase["lblUserType"] : arPhrase["lblUserType"]}
          </label>

          <Controller
            name="customer"
            rules={{ required: "party Types is required" }}
            control={control}
            render={({ field }) => (
              <Select
                components={{ DropdownIndicator: CustomDropdownIndicator }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblUserTypeHolder"]
                      : arPhrase["lblUserTypeHolder"]}
                  </div>
                }
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.customer ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={partyTypes?.[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                options={partyTypes}
                getOptionLabel={(o) => o["name"]}
                getOptionValue={(o) => o["id"]}
                formatOptionLabel={formatOptionLabel}
                filterOption={(candidate, input) =>
                  candidate.data.nameForSearch
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    customer: selected,
                  }));
                  clearErrors("customer");
                }}
              />
            )}
          />

          {errors.customer && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lblUserTypeError"]
                : arPhrase["lblUserTypeError"]}
            </span>
          )}
        </div>

        {/* ---------------- Mobile ---------------- */}
        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="mobile"
            className={`block text-[12px] mb-1 ${
              errors.mobile || errors.code
                ? "text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblMobileNumberOptional"]
              : arPhrase["lblMobileNumberOptional"]}
          </label>

          <div
            ref={phoneWrapRef}
            className={`w-full flex items-center bg-white h-[40px] rounded-lg border transition-all ${
              errors.mobile || errors.code
                ? "border-red-600"
                : "border-gray-300 focus-within:border-[#B68A35]"
            } ${lang === "en" ? "" : "flex-row-reverse"}`}
          >
            {/* Country */}
            <div className="w-[130px] h-full">
              <Controller
                name="code"
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    // Keep menuIsOpen={true} only for debugging purposes
                    // menuIsOpen={true}
                    theme={customTheme}
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                    options={countries}
                    isRtl={isRtl}
                    isSearchable
                    formatOptionLabel={formatOptionLabelCode}
                    filterOption={(candidate, input) => {
                      const { name, dial_code } = candidate.data;
                      const searchString = `${name} ${dial_code}`.toLowerCase();
                      return searchString.includes(input.toLowerCase());
                    }}
                    // ✅ Portal to body allows the menu to overflow the container
                    menuPortalTarget={
                      typeof document !== "undefined" ? document.body : null
                    }
                    // ✅ Fixed position is more reliable for anchoring during RTL/LTR swaps
                    menuPosition="fixed"
                    onMenuOpen={() => requestAnimationFrame(measurePhoneWrap)}
                    styles={{
                      ...customStyles,

                      control: (base) => ({
                        ...base,
                        border: "none",
                        boxShadow: "none",
                        backgroundColor: "transparent",
                        minHeight: "38px",
                        height: "38px",
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 8px",
                        gap: "2px",
                      }),

                      input: (base) => ({
                        ...base,
                        width: 0,
                        minWidth: 0,
                        padding: 0,
                        margin: 0,
                        opacity: 1,
                        caretColor: "transparent",
                      }),

                      // ✅ Updated Menu Styles
                      menu: (base) => ({
                        ...base,
                        backgroundColor: "#B68A35",
                        borderRadius: "4px",
                        marginTop: "4px",
                        border: "none",
                        // Matches the width of the total phone input wrapper
                        width: phoneWrapWidth || base.width,
                        // Resetting these allows isRtl logic to take over positioning
                        left: "auto",
                        right: "auto",
                      }),

                      // ✅ Updated Portal Styles
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                        // Forces the coordinate system to flip for Arabic
                        direction: isRtl ? "rtl" : "ltr",
                      }),

                      menuList: (base) => ({
                        ...base,
                        padding: 0,
                        backgroundColor: "#B68A35",
                        maxHeight: 220,
                      }),

                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isSelected
                          ? "#fff"
                          : isFocused
                            ? "#c9a154"
                            : "#B68A35",
                        color: isSelected ? "#B68A35" : "white",
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderBottom: "0.5px solid rgba(255, 255, 255, 0.1)",
                        ":active": { backgroundColor: "#9c752d" },
                      }),

                      singleValue: (base) => ({
                        ...base,
                        color: "#000",
                      }),
                    }}
                    defaultValue={{
                      name: "United Arab Emirates (UAE)",
                      code: "AE",
                      dial_code: "+971",
                    }}
                    onChange={(selected) => {
                      field.onChange(selected);

                      setSharedValues((prev) => ({
                        ...prev,
                        country_code: selected?.dial_code,
                        selectedCountry: selected,
                      }));

                      setMobileNumber((prev) => ({
                        ...prev,
                        country_code: selected?.dial_code,
                      }));

                      clearErrors("code");
                    }}
                  />
                )}
              />
            </div>

            <div className="w-[1px] h-[24px] bg-[#EEE2D0] shrink-0" />

            {/* Mobile input */}
            <input
              type="tel"
              inputMode="numeric"
              dir={lang === "en" ? "ltr" : "rtl"}
              style={{ textAlign: lang === "en" ? "left" : "right" }}
              {...register("mobile", {
                required: false,
                maxLength: mobileNumber.country_code === "+971" ? 9 : undefined,
                minLength: mobileNumber.country_code === "+971" ? 9 : undefined,
                onChange: (e) => {
                  const value = e.target.value;

                  setSharedValues((prev) => ({
                    ...prev,
                    mobile: value || "",
                  }));

                  setMobileNumber((prev) => ({
                    ...prev,
                    number: value || "",
                  }));
                },
                onBlur: () => trigger("mobile"),
              })}
              placeholder={
                lang === "en"
                  ? enPhrase["lblMobileNumber"]
                  : arPhrase["lblMobileNumber"]
              }
              className="flex-1 border-none focus:ring-0 !text-[14px] px-2 bg-transparent h-full remove-arrow"
            />
          </div>

          {(errors.mobile || errors.code) && (
            <span role="alert" className="text-xs text-red-600 mt-1 block">
              {lang === "en"
                ? enPhrase["lbl_error_mobile_number"]
                : arPhrase["lbl_error_mobile_number"]}
            </span>
          )}
        </div>

        {/* ---------------- Email ---------------- */}
        <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="Email"
              className={`block text-[12px] ${
                errors.Email
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              {lang === "en"
                ? enPhrase["lblEmailRequestField"]
                : arPhrase["lblEmailRequestField"]}
            </label>

            <input
              type="text"
              name="Email"
              key="Email"
              placeholder={
                lang === "en"
                  ? enPhrase["lblEmailRequestFieldPlaceHolder"]
                  : arPhrase["lblEmailRequestFieldPlaceHolder"]
              }
              aria-invalid={errors.Email ? "true" : "false"}
              {...register("Email", {
                required: false,
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message:
                    lang === "en"
                      ? enPhrase["lblEmailCorrectError"]
                      : arPhrase["lblEmailCorrectError"],
                },
                onBlur: () => trigger("Email"),
                onChange: (e) => {
                  clearErrors("Email");
                  setSharedValues((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }));
                },
              })}
              className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 !text-[13px] sm:text-sm !leading-[20px] ${
                errors.Email ? " border-red-600" : " border-gray-300"
              }`}
            />

            {errors.Email && (
              <span role="alert" className=" text-xs text-red-600">
                {errors.Email.message}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseBasicInfo;
